var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 1.75C6.39137 1.75 2.25 5.89137 2.25 11C2.25 16.1086 6.39137 20.25 11.5 20.25C16.6086 20.25 20.75 16.1086 20.75 11C20.75 5.89137 16.6086 1.75 11.5 1.75ZM0.75 11C0.75 5.06294 5.56294 0.25 11.5 0.25C17.4371 0.25 22.25 5.06294 22.25 11C22.25 16.9371 17.4371 21.75 11.5 21.75C5.56294 21.75 0.75 16.9371 0.75 11ZM11.5 6.25C11.9142 6.25 12.25 6.58579 12.25 7V10.6893L14.5303 12.9697C14.8232 13.2626 14.8232 13.7374 14.5303 14.0303C14.2374 14.3232 13.7626 14.3232 13.4697 14.0303L10.9697 11.5303C10.829 11.3897 10.75 11.1989 10.75 11V7C10.75 6.58579 11.0858 6.25 11.5 6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.76426228bd160bb4c36118e5fcfce808.svg";
export { ForwardRef as ReactComponent };